<template>
  <div class="revenue-center">
    <div class="columns">
      <div class="column">
        <div class="group">
          <LocalizedInput :title="$t('name')" :translate="value.name" />
        </div>
        <div class="group">
          <LocalizedInput :title="$t('description')" :translate="value.description" />
        </div>
      </div>

      <div class="column">

      </div>
    </div>

    <div class="tabs" style="margin-top: 20px">
      <div class="tab" :class="{active: tab === 'layout'}" @click="tab = 'layout'">DEFAULT LAYOUT</div>
      <div class="tab" :class="{active: tab === 'modes'}" @click="tab = 'modes'">MODES</div>
    </div>

    <!-- TAB: DEFAULT LAYOUT -->
    <div class="tab-content" v-if="tab === 'layout'">
      <PosLayout
        v-if="value.posLayout"
        v-model="value.posLayout"
        :functions="functions"
        ref="posLayoutComponent"
      />
      <div v-else>
        <button class="btn btn-primary" @click="initPosLayout">+</button>
      </div>
    </div>

    <!-- TAB: MODES -->
    <div class="tab-content" v-else-if="tab === 'modes'">
      <div class="rc-mode" v-for="(rcMode, i) of value.modes" :key="`rc_${value.id}_mode_${rcMode.id}`">
        <button class="btn btn-primary" @click="removeMode(i)">X</button>
        <div>{{$to(rcMode.name)}}</div>
      </div>
      <select v-model="addModeSelect">
        <option :value="null">CHOOSE MODE TO ADD</option>
        <option :value="m" v-for="m of remainingPosModes" :key="`rc_${value.id}_add_${m.id}`">{{$to(m.name)}}</option>
      </select>
    </div>

  </div>
</template>

<script>
import LocalizedInput from "@/components/tools/LocalizedInput";
import PosLayout from "@/components/qsr/PosLayout";

export default {
  name: "RevenueCenter",
  components: {LocalizedInput, PosLayout},

  props: {
    value: Object,
    functions: Array,
    posModes: Array
  },

  data() {
    return {
      tab: 'layout',
      addModeSelect: null,
    }
  },

  computed: {
    remainingPosModes() {
      return this.posModes.filter(m => !this.alreadyIncludedModeIds.includes(m.id));
    },
    alreadyIncludedModeIds() {
      return this.value.modes.map(m => m.id);
    }
  },

  watch: {
    addModeSelect(mode) {
      if (!mode) { return; }

      this.addModeSelect = null;
      this.value.modes.push({
        id: mode.id,
        name: mode.name
      });
    }
  },

  methods: {
    newElementData() {
      return {
        id: null,
        name: {},
        description: {},
        posLayout: null,
        modes: []
      }
    },

    initPosLayout() {
      this.value.posLayout = PosLayout.methods.newElementData();
      this.value.posLayout.name = `Layout ${this.$to(this.value.name)}`;
    },

    removeMode(index) {
      this.value.modes.splice(index, 1);
    }
  }
}
</script>

<style lang="scss" scoped>
.tab-content {
  margin: 20px 0
}
.rc-mode {
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  :not(:last-child) {
    margin-right: 8px;
  }
}
</style>